/* eslint-disable prettier/prettier */
import { clsx } from 'clsx'
import { PropertyValueMap,unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../../../internal/dds-hu-element'
import styles from '../../../icon/_styles/icon.scss?inline'

/**
 * `dap-ds-icon-account-circle-line`
 * @summary An icon
 * @element dap-ds-icon-account-circle-line
 * @title - UserAccountCircleLine
 * @group icon
 * @icontype user
 * 
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
@customElement('dap-ds-icon-account-circle-line')
export default class UserAccountCircleLine extends DdsElement {
  /** (optional) The width and height in pixels */
  @property({ type: Number, reflect: true }) size? = 24
  /** (optional) Sets the icon color via the `fill` attribute */
  @property({ type: Boolean, reflect: true }) selected?: boolean = false
  /** (optional) When using the icon standalone, make it meaningful for accessibility */
  @property() accessibilityTitle?: string
  /** (optional) If `true` the icon can receive focus */
  @property({ type: Boolean }) focusable?: boolean = false

  static readonly styles = unsafeCSS(styles)

  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties)

    this.classList.add('dap-ds-icon')
  }

  render() {
    return html`
      <svg
        part="base"
        class=${clsx('icon', 'dap-ds-icon-account-circle-line')}
        xmlns="http://www.w3.org/2000/svg"
        width=${this.size}
        height=${this.size}
        viewBox="0 0 24 24"
        tabindex=${this.focusable ? 0 : -1}
        aria-hidden=${this.ariaHidden ?? 'true'}>
        ${this.accessibilityTitle
          ? html`<title>${this.accessibilityTitle}</title>`
          : null}
        <g part="container">
          <g>
            <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m.16 14a6.98 6.98 0 0 0-5.147 2.256A7.97 7.97 0 0 0 12 20c1.97 0 3.773-.712 5.167-1.892A6.98 6.98 0 0 0 12.16 16M12 4a8 8 0 0 0-6.384 12.821A8.98 8.98 0 0 1 12.16 14a8.97 8.97 0 0 1 6.362 2.634A8 8 0 0 0 12 4m0 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"></path>
          </g>
        </g>
      </svg>
    `
  }
}
